import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle, Clock, CheckCircle, Users } from "lucide-react";

export default function StatusCards({ stats }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      
      {/* Open Tickets */}
      <Card className="rounded-2xl border-none shadow-sm bg-red-50">
        <CardContent className="p-5 flex justify-between items-center">
          <div>
            <p className="text-sm text-gray-600">Open Tickets</p>
            <h2 className="text-3xl font-bold">{stats.open}</h2>
            <p className="text-xs text-red-500 mt-1">Needs attention</p>
          </div>
          <div className="p-3 bg-red-100 rounded-xl">
            <AlertTriangle className="text-red-500" size={26} />
          </div>
        </CardContent>
      </Card>

      {/* In Progress */}
      <Card className="rounded-2xl border-none shadow-sm bg-yellow-50">
        <CardContent className="p-5 flex justify-between items-center">
          <div>
            <p className="text-sm text-gray-600">In Progress</p>
            <h2 className="text-3xl font-bold">{stats.inProgress}</h2>
            <p className="text-xs text-yellow-600 mt-1">Being worked on</p>
          </div>
          <div className="p-3 bg-yellow-100 rounded-xl">
            <Clock className="text-yellow-600" size={26} />
          </div>
        </CardContent>
      </Card>

      {/* Resolved */}
      <Card className="rounded-2xl border-none shadow-sm bg-green-50">
        <CardContent className="p-5 flex justify-between items-center">
          <div>
            <p className="text-sm text-gray-600">Resolved</p>
            <h2 className="text-3xl font-bold">{stats.resolved}</h2>
            <p className="text-xs text-green-600 mt-1">Completed</p>
          </div>
          <div className="p-3 bg-green-100 rounded-xl">
            <CheckCircle className="text-green-600" size={26} />
          </div>
        </CardContent>
      </Card>

      {/* Assigned to Me */}
      <Card className="rounded-2xl border-none shadow-sm bg-blue-50">
        <CardContent className="p-5 flex justify-between items-center">
          <div>
            <p className="text-sm text-gray-600">Assigned to Me</p>
            <h2 className="text-3xl font-bold">{stats.assignedToMe}</h2>
            <p className="text-xs text-blue-600 mt-1 cursor-pointer hover:underline">
              Your tickets
            </p>
          </div>
          <div className="p-3 bg-blue-100 rounded-xl">
            <Users className="text-blue-600" size={26} />
          </div>
        </CardContent>
      </Card>

    </div>
  );
}
